import React, { useState } from 'react';
import Header from "./header";
import TabsController from "./TabsController";

function MyTaskPage() {
  // Add state to track the current tab
  const [currentTab, setCurrentTab] = useState("my-planner");
  
  return (
    <>
      <Header currentTab={currentTab} />
      <TabsController 
        initialTab={currentTab} 
        onTabChange={(tab) => setCurrentTab(tab)} 
      />
    </>
  );
}

export default MyTaskPage